export default __webpack_public_path__ + "static/media/Activity9.a00bea0c.jpeg";